// src/Pages/Products/Prices.js

export const CURRENCY = "USD";

export const PRICES = {
  "topical-luteolin-serum": {
    variants: {
      "30ml (1 oz)": 44,
      "50ml": 57,
      "100ml": 95,
    },
    defaultVariant: "30ml (1 oz)",
  },

  "topical-luteolin-lotion": {
    variants: {
      "30ml": 46,
      "50ml": 59,
    },
    defaultVariant: "30ml",
  },

  "topical-luteolin-cream": {
    variants: {
      "50ml": 47,
      "100ml": 72,
    },
    defaultVariant: "50ml",
  },
};

export function getVariantPrices(productId) {
  const product = PRICES[productId];
  return product?.variants ?? {};
}

export function getDefaultVariant(productId) {
  const product = PRICES[productId];
  const variants = product?.variants ?? {};
  return product?.defaultVariant || Object.keys(variants)[0] || "";
}

export function getPrice(productId, variantName) {
  const variants = getVariantPrices(productId);
  const price = variants?.[variantName];

  if (typeof price !== "number") return null;
  return price;
}

export function formatPrice(value, currency = CURRENCY) {
  if (typeof value !== "number") return "";
  if (currency === "USD") return `$${value.toFixed(2)}`;
  return `${value.toFixed(2)} ${currency}`;
}

export function getPriceRange(productId) {
  const variants = getVariantPrices(productId);
  const values = Object.values(variants).filter((v) => typeof v === "number");
  if (!values.length) return null;

  const min = Math.min(...values);
  const max = Math.max(...values);
  return { min, max };
}

export function getPriceDisplay(productId, currency = CURRENCY) {
  const range = getPriceRange(productId);
  if (!range) return "";

  const { min, max } = range;
  if (min === max) return formatPrice(min, currency);

  const minNoCents = min % 1 === 0 ? `$${min.toFixed(0)}` : `$${min.toFixed(2)}`;
  const maxNoCents = max % 1 === 0 ? `$${max.toFixed(0)}` : `$${max.toFixed(2)}`;
  return `${minNoCents} – ${maxNoCents}`;
}
